<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
@if (!isBottomSheet) {
  <div class="map-toolbar">
    <mat-toolbar class="no-print">
      <section fxLayout="row" fxLayoutAlign="space-between center">
        @for (widget of visibleWidgets$ | async; track widget.commandName) {
          <dash-gis-map-toolbar-widget [hotKey]='widget.hotKey'
            [commandName]='widget.commandName'
            [icon]='widget.icon'
            [label]='widget.label'
            [isInBottomSheet]='isBottomSheet'
          [attributes]='widget.attributes'></dash-gis-map-toolbar-widget>
        }
      </section>
    </mat-toolbar>
  </div>
}
@if (isBottomSheet) {
  <div class="map-toolbar-bottomsheet">
    <mat-grid-list [cols]="bottomSheetColumnCount$ | async">
      @for (widget of visibleWidgets$ | async; track widget) {
        <mat-grid-tile>
          <div style='display:none'>{{ widget | json }}</div>
          <dash-gis-map-toolbar-widget [hotKey]='widget.hotKey'
            [commandName]='widget.commandName'
            [icon]='widget.icon'
            [label]='widget.label'
            [isInBottomSheet]='isBottomSheet'
            [attributes]='widget.attributes'
          (shouldPreventClose)='handleShouldPreventClose($event)'></dash-gis-map-toolbar-widget>
        </mat-grid-tile>
      }
    </mat-grid-list>
  </div>
}
